export default __webpack_public_path__ + "static/media/logo.48eee3e5.svg";